var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarToday({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 1.86364H11.725V0.5H10.375V1.86364H3.625V0.5H2.275V1.86364H1.6C0.8575 1.86364 0.25 2.47727 0.25 3.22727V14.1364C0.25 14.8864 0.8575 15.5 1.6 15.5H12.4C13.1425 15.5 13.75 14.8864 13.75 14.1364V3.22727C13.75 2.47727 13.1425 1.86364 12.4 1.86364ZM12.4 14.1364H1.6V6.63636H12.4V14.1364ZM12.4 5.27273H1.6V3.22727H12.4V5.27273Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/CalendarToday.06bcc64b.svg";
export { ForwardRef as ReactComponent };